<ng-container *ngIf="showIsUrgentPrompt || isTreePermitOverride">
    <div class="heading isUrgent">
        <i class="fas fa-exclamation-triangle"></i>
        <span>{{headerBannerMsg}}</span>
    </div>
</ng-container>

<ng-container *ngIf="showRedirectionMsg && !isTreePermitOverride">
    <div class="heading">
        <i class="fas fa-exclamation-circle"></i>
        <span>{{headerBannerMsg}}</span>
    </div>
</ng-container>

<ng-container *ngIf="isTreeSafetyNeeded">
    <div class="safetyNotification">
        <div class="safetyNotificationText"><span>Call 9-1-1 first</span> if you believe the problem is putting someone's safety at risk.</div>
    </div>
</ng-container>

<div class="generalMsg" [innerHTML]="generalMessage"></div>
<!-- <div class="addressAnchor" *ngIf="addressLink.length > 0">
    <a href="{{addressLink}}" target="_blank">Click here for more information</a>
</div> -->

<div class="moreInfoContainer">
    <ng-container *ngFor="let message of messageBox">
        <div class="container">
            <div class="titleRow">
                <div class="messageTitle">{{message.title}}</div>
                <span class="messageTitleInfo" *ngIf="message.titleInfo.length > 0">{{message.titleInfo}}</span>
            </div>
            <div class="message" [innerHTML]="message.message"></div>
        </div>
    </ng-container>
</div>

<div class="isUrgentInfoTag" *ngIf="showIsUrgentPrompt">If your problem is not urgent, please continue creating your report.</div>